import * as React from "react"
import { Link } from "gatsby"

import Container from "../container/container"

import * as styles from "./banner.module.scss"
import Markdown from "react-markdown"

const AboutBanner = props => (
  <div className={styles.banner}>
    <div className={styles.banner__overlay}></div>
    <Container>
      <div className={styles.banner__content}>
        <h1>{props.data.BannerSubHeading}</h1>
        <h2>{props.data.BannerHeading}</h2>
        <Markdown>{props.data.BannerBody}</Markdown>
        <div
          className={`${styles.banner__ctas} d-flex align-items-center justify-content-start`}
        >
          {props.data.Ctas.map((btn, key) => (
            <Link to={btn.ButtonLink} className="cta" key={key}>
              {btn.ButtonText}
            </Link>
          ))}
        </div>
      </div>
    </Container>
  </div>
)

export default AboutBanner
